"use strict";

exports.__esModule = true;
exports.getTooltipContentPosition = exports.calculateTooltipPosition = void 0;
var calculateTooltipPosition = exports.calculateTooltipPosition = function calculateTooltipPosition(_ref) {
  var xPosition = _ref.xPosition,
    yPosition = _ref.yPosition,
    scatterPlotRadius = _ref.scatterPlotRadius,
    height = _ref.height,
    width = _ref.width;
  var top, bottom, left, right;
  if (yPosition > height / 2) {
    top = "unset";
    bottom = -yPosition + scatterPlotRadius * 2 + "px";
  } else {
    bottom = "unset";
    top = yPosition + "px";
  }
  if (xPosition > width / 2) {
    left = "unset";
    right = -xPosition + "px";
  } else {
    right = "unset";
    left = xPosition + "px";
  }
  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
};
var getTooltipContentPosition = exports.getTooltipContentPosition = function getTooltipContentPosition(_ref2) {
  var cursorXPosition = _ref2.cursorXPosition,
    cursorYPosition = _ref2.cursorYPosition,
    height = _ref2.height,
    tooltipContentHeight = _ref2.tooltipContentHeight,
    position = _ref2.position;
  var top, left, right;
  var boundaryBottom = height - tooltipContentHeight - 10;
  top = cursorYPosition - tooltipContentHeight / 2;
  if (top < 10) {
    top = 10;
  } else if (top > boundaryBottom) {
    top = boundaryBottom;
  }
  left = cursorXPosition + 20;
  if (left < 10) {
    left = 10;
  }
  if (position === "left") {
    right = -cursorXPosition + 20;
    left = null;
  }
  return {
    top: top,
    left: left,
    right: right
  };
};